import {Rect, Size} from './types';

type Results = {left: number | undefined; top: number | undefined};

export const getPopupPosition = (
  triggerBounds: Rect,
  popupSize: Size,
  screenSize: Size,
  padding = 0,
): Results => {
  let left = triggerBounds.x;
  let top = triggerBounds.y + triggerBounds.height + padding;
  // Vertical values
  if (
    triggerBounds.y + triggerBounds.height + popupSize.height >
    screenSize.height
  ) {
    top = triggerBounds.y - popupSize.height - padding;
  }
  // Horizontal
  if (triggerBounds.x + popupSize.width > screenSize.width) {
    left = triggerBounds.x - popupSize.width + padding;
  }

  return {left, top};
};
